module.exports = __webpack_public_path__ + "2fe8548f4e2045b7a60f0fae3740ae64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C0000B5A3.png
// module id = 1714
// module chunks = 0